t = require('views/internal/teacup-with-helpers')('card_title_on_card_front')

module.exports = ->
  # guide/hacks/id-short
  t.mustacheBlock 'idShort', ->
    t.span '.card-short-id.hide', ->
      t.format 'idshort', { idShort: t.mustacheVar('idShort') }
  t.text t.mustacheVar('name')



// WEBPACK FOOTER //
// ./app/scripts/views/templates/card_title_on_card_front.coffee